import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Card, CardContent, Skeleton } from '@mui/material'

const useStyles = makeStyles()((theme) => ({
  skeletonCard: {
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(1),
  },
  skeletonCardContent: {
    padding: theme.spacing(2),
    '&:last-of-type': {
      paddingBottom: theme.spacing(2),
    },
  },
  skeletonHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
  },
}))

const SkeletonCard: React.FC = () => {
  const { classes } = useStyles()

  return (
    <Card className={classes.skeletonCard}>
      <CardContent className={classes.skeletonCardContent}>
        <div className={classes.skeletonHeader}>
          <Skeleton variant="text" width="40%" height={24} />
          <Skeleton variant="text" width="25%" height={20} />
        </div>
        <Skeleton variant="text" width="60%" height={16} />
      </CardContent>
    </Card>
  )
}

export default SkeletonCard
